/**
 * Substring string
 * @param value
 * @param len
 * @param addDots
 * @param fullLen
 * @return string
 */
export const abbreviateString = (value: string, len = 15, addDots = true, fullLen = 20): string => {
  if (value && value.length > fullLen) {
    return `${value.substring(0, len)}${addDots ? '...' : ''}`
  }
  return value
}
